/**
 * utils.js — Shared utility helpers for the M16S frontend.
 *
 * Exports: cn
 */
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * cn — Merges Tailwind CSS class names safely.
 *
 * Combines clsx (handles conditionals, arrays, and objects) with tailwind-merge
 * (resolves conflicting Tailwind utilities so the last one wins, e.g. "p-2 p-4"
 * becomes "p-4" instead of both being emitted).
 *
 * Use this whenever a component needs to merge a base set of classes with
 * caller-provided className overrides.
 *
 * @param {...any} inputs - Any mix of strings, arrays, or condition objects accepted by clsx.
 * @returns {string} A single deduplicated and conflict-resolved class string.
 *
 * @example
 * cn("px-4 py-2", isActive && "bg-primary", className)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
